import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { scanToEarnService } from 'src/services/scan-to-earn.service'

export const useGetAllProductTypes = () => {
  return useQuery(
    [QUERY_KEYS.SCAN_TO_EARN_PRODUCT_TYPES],
    () => scanToEarnService.getConsumerScansProductTypes(),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  )
}
